(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("trainmanjs", [], factory);
	else if(typeof exports === 'object')
		exports["trainmanjs"] = factory();
	else
		root["trainmanjs"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var noop = function noop() {
  return null;
};

var DEFAULT_TRAINMAN_CONFIG = exports.DEFAULT_TRAINMAN_CONFIG = {
  handshakeInterval: 0.5 * 1000,
  debug: false,
  debugCallback: noop
};

var DEFAULT_PASSENGER_CONFIG = exports.DEFAULT_PASSENGER_CONFIG = {
  debug: false,
  debugCallback: noop
};

var TOPIC_KEY = exports.TOPIC_KEY = 'topic';
var DATA_KEY = exports.DATA_KEY = 'data';
var FINGERPRINT_KEY = exports.FINGERPRINT_KEY = 'fingerprint';
var MESSAGE_EVENT_NAME = exports.MESSAGE_EVENT_NAME = 'message';
var UNLOAD_EVENT_NAME = exports.UNLOAD_EVENT_NAME = 'unload';

var HANDSHAKE_TOPIC = exports.HANDSHAKE_TOPIC = 'HANDSHAKE';
var BACK_HANDSHAKE_TOPIC = exports.BACK_HANDSHAKE_TOPIC = 'BACK_HANDSHAKE';
var CLIENT_DISCONNECTED_TOPIC = exports.CLIENT_DISCONNECTED_TOPIC = 'CLIENT_DISCONNECTED';

var IFRAME_INTERFACE = exports.IFRAME_INTERFACE = window.HTMLIFrameElement;

var FINGERPRINT = exports.FINGERPRINT = '7r41nm4nj5';

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventMessageSupported = exports.createHostFromMessage = exports.createEmptyHost = exports.buildMessage = exports.retrieveMessageFromEvent = exports.isMatchingOrigin = exports.getOriginFromUri = exports.isHandshake = exports.getOrigin = exports.isClientConnected = exports.isElAnIframe = undefined;

var _constants = __webpack_require__(0);

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HOST_REGEXP = /https?:\/\/[a-z0-9\-.:]+\/?/i;

var isElAnIframe = exports.isElAnIframe = function isElAnIframe(el) {
  return el instanceof CONSTANTS.IFRAME_INTERFACE;
};

var isClientConnected = exports.isClientConnected = function isClientConnected(client) {
  return Boolean(client.connected);
};

var getOrigin = exports.getOrigin = function getOrigin() {
  return window.location.origin;
};

var isHandshake = exports.isHandshake = function isHandshake(topic) {
  return topic === CONSTANTS.HANDSHAKE_TOPIC;
};

var getOriginFromUri = exports.getOriginFromUri = function getOriginFromUri(uri) {
  return uri.match(HOST_REGEXP).pop().replace(/\/$/, '');
};

var isMatchingOrigin = exports.isMatchingOrigin = function isMatchingOrigin(targetOrigin, sourceOrigin) {
  var isMatching = targetOrigin === sourceOrigin;

  return isMatching;
};

var retrieveMessageFromEvent = exports.retrieveMessageFromEvent = function retrieveMessageFromEvent(event) {
  var source = event.source,
      sourceOrigin = event.origin;
  var _event$data = event.data,
      topic = _event$data[CONSTANTS.TOPIC_KEY],
      data = _event$data[CONSTANTS.DATA_KEY];


  return { topic: topic, data: data, source: source, sourceOrigin: sourceOrigin };
};

var buildMessage = exports.buildMessage = function buildMessage(topic) {
  var _message;

  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var message = (_message = {}, _defineProperty(_message, CONSTANTS.TOPIC_KEY, topic), _defineProperty(_message, CONSTANTS.FINGERPRINT_KEY, CONSTANTS.FINGERPRINT), _message);

  if (data !== null) {
    message[CONSTANTS.DATA_KEY] = data;
  }

  return message;
};

var createEmptyHost = exports.createEmptyHost = function createEmptyHost() {
  return {
    origin: null,
    source: null,
    connected: false
  };
};

var createHostFromMessage = exports.createHostFromMessage = function createHostFromMessage(message) {
  var source = message.source,
      origin = message.sourceOrigin;


  return { origin: origin, source: source, connected: true };
};

var isEventMessageSupported = exports.isEventMessageSupported = function isEventMessageSupported(event) {
  var data = event.data;


  return data[CONSTANTS.FINGERPRINT_KEY] === CONSTANTS.FINGERPRINT;
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(0);

var CONSTANTS = _interopRequireWildcard(_constants);

var _utils = __webpack_require__(1);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Passenger = function () {
  function Passenger() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CONSTANTS.DEFAULT_PASSENGER_CONFIG;

    _classCallCheck(this, Passenger);

    this.config = _extends({}, CONSTANTS.DEFAULT_PASSENGER_CONFIG, config);

    this.host = utils.createEmptyHost();
    this.subjects = {};
    this.queue = [];

    this.debug('Starting new Passenger instance');

    this.handleIncomingMessage = this.handleIncomingMessage.bind(this);
    this.handleFrameUnload = this.handleFrameUnload.bind(this);
    this.setHostAsConnected = this.setHostAsConnected.bind(this);

    this.addEventHandlers();
    this.waitForHandshake();
  }

  _createClass(Passenger, [{
    key: 'post',
    value: function post(topic, data) {
      var message = { topic: topic, data: data };

      this.postMessage(message);

      return this;
    }
  }, {
    key: 'on',
    value: function on(topic, callback) {
      var listener = { topic: topic, callback: callback };

      this.subjects[topic] = this.subjects[topic] || [];
      this.subjects[topic].push(listener);

      this.debug('Adding "' + topic + '" topic listener');

      return this;
    }
  }, {
    key: 'off',
    value: function off(topic, callback) {
      var fn = callback ? this.offTopicCallback : this.offTopics;

      this.debug('Removing "' + topic + '" topic listener');

      fn.call(this, topic, callback);

      return this;
    }

    /**
     * @private
     */

  }, {
    key: 'addEventHandlers',
    value: function addEventHandlers() {
      window.addEventListener(CONSTANTS.MESSAGE_EVENT_NAME, this.handleIncomingMessage);
      window.addEventListener(CONSTANTS.UNLOAD_EVENT_NAME, this.handleFrameUnload);
    }

    /**
     * @private
     */

  }, {
    key: 'handleFrameUnload',
    value: function handleFrameUnload() {
      this.debug('Frame is unloading it-self');

      this.post(CONSTANTS.CLIENT_DISCONNECTED_TOPIC);
    }

    /**
     * @private
     */

  }, {
    key: 'handleIncomingMessage',
    value: function handleIncomingMessage(event) {
      var _this = this;

      if (!utils.isEventMessageSupported(event)) {
        return;
      }

      var _utils$retrieveMessag = utils.retrieveMessageFromEvent(event),
          topic = _utils$retrieveMessag.topic,
          data = _utils$retrieveMessag.data,
          source = _utils$retrieveMessag.source,
          sourceOrigin = _utils$retrieveMessag.sourceOrigin;

      var listeners = this.subjects[topic];


      if (!Array.isArray(listeners)) {
        this.debug('Received message from host with "' + topic + '" topic but there are no listeners than can handle it');

        return;
      }

      this.debug('Received message from host with "' + topic + '" topic');

      listeners.forEach(function (listener) {
        if (!_this.isMatchingOrigin(sourceOrigin, topic)) {
          return;
        }

        var message = { topic: topic, source: source, sourceOrigin: sourceOrigin, data: data };

        listener.callback(message);
      });
    }

    /**
     * @private
     */

  }, {
    key: 'isMatchingOrigin',
    value: function isMatchingOrigin(sourceOrigin, topic) {
      var hostOrigin = this.host.origin;

      var isMatching = sourceOrigin === hostOrigin || utils.isHandshake(topic);

      return isMatching;
    }

    /**
     * @private
     */

  }, {
    key: 'postMessageToHost',
    value: function postMessageToHost(topic, data) {
      var _host = this.host,
          source = _host.source,
          targetOrigin = _host.origin;

      var message = utils.buildMessage(topic, data);

      this.debug('Sending message to host with "' + topic + '" topic');

      source.postMessage(message, targetOrigin);
    }

    /**
     * @private
     */

  }, {
    key: 'waitForHandshake',
    value: function waitForHandshake() {
      this.debug('Waiting for host to send handshake...');

      this.on(CONSTANTS.HANDSHAKE_TOPIC, this.setHostAsConnected);
    }

    /**
     * @private
     */

  }, {
    key: 'sendBackHandshake',
    value: function sendBackHandshake() {
      this.post(CONSTANTS.BACK_HANDSHAKE_TOPIC);
    }

    /**
     * @private
     */

  }, {
    key: 'setHostAsConnected',
    value: function setHostAsConnected(message) {
      this.debug('Host was connected');

      this.off(CONSTANTS.HANDSHAKE_TOPIC);
      this.host = utils.createHostFromMessage(message);
      this.sendBackHandshake();
      this.deliverQueuedMessages();
    }

    /**
     * @private
     */

  }, {
    key: 'addMessageToQueue',
    value: function addMessageToQueue(message) {
      this.debug('Adding message with "' + message.topic + '" topic to queue');

      this.queue.push(message);
    }

    /**
     * @private
     */

  }, {
    key: 'deliverQueuedMessages',
    value: function deliverQueuedMessages() {
      if (this.queue.length < 1) {
        return;
      }

      this.debug('Delivering queued messages to host');

      this.queue.forEach(this.postMessage, this);
      this.queue.length = 0;
    }

    /**
     * @private
     */

  }, {
    key: 'postMessage',
    value: function postMessage(message) {
      var topic = message.topic,
          data = message.data;


      if (!this.isHostConnected()) {
        this.addMessageToQueue(message);

        return;
      }

      this.postMessageToHost(topic, data);
    }

    /**
     * @private
     */

  }, {
    key: 'isHostConnected',
    value: function isHostConnected() {
      return this.host.connected;
    }

    /**
     * @private
     */

  }, {
    key: 'offTopics',
    value: function offTopics(topic) {
      delete this.subjects[topic];
    }

    /**
     * @private
     */

  }, {
    key: 'offTopicCallback',
    value: function offTopicCallback(topic, callback) {
      var listeners = this.subjects[topic];


      if (!Array.isArray(listeners) || !listeners.length) {
        return;
      }

      listeners = listeners.filter(function (listener) {
        return listener.callback !== callback;
      });

      this.subjects[topic] = listeners;
    }

    /**
     * @private
     */

  }, {
    key: 'debug',
    value: function debug(message) {
      var debugCallback = this.config.debugCallback;

      if (!this.config.debug || typeof debugCallback !== 'function') {
        return;
      }

      debugCallback('Passenger: ' + message);
    }
  }]);

  return Passenger;
}();

exports.default = Passenger;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(0);

var CONSTANTS = _interopRequireWildcard(_constants);

var _utils = __webpack_require__(1);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Trainman = function () {
  function Trainman() {
    var frame = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CONSTANTS.DEFAULT_TRAINMAN_CONFIG;

    _classCallCheck(this, Trainman);

    this.config = _extends({}, CONSTANTS.DEFAULT_TRAINMAN_CONFIG, config);

    this.intervals = {};
    this.clients = {};
    this.subjects = {};
    this.queue = [];

    this.debug('Starting new Trainman instance');

    this.handleIncomingMessage = this.handleIncomingMessage.bind(this);

    this.addEventHandlers();

    if (frame !== null) {
      var frames = Array.isArray(frame) ? frame : [frame];
      this.setClients.apply(this, _toConsumableArray(frames));
    }
  }

  _createClass(Trainman, [{
    key: 'addClient',
    value: function addClient(frame) {
      this.setClient(frame);

      return this;
    }
  }, {
    key: 'post',
    value: function post(clientId, topic, data) {
      if (!this.getClient(clientId)) {
        return this;
      }

      var message = { clientId: clientId, topic: topic, data: data };
      this.postMessage(message);

      return this;
    }
  }, {
    key: 'on',
    value: function on(clientId, topic, callback) {
      var client = this.getClient(clientId);

      if (!client) {
        return this; // TODO: Check this
      }

      var targetOrigin = client.targetOrigin;

      var listener = { targetOrigin: targetOrigin, callback: callback, clientId: clientId, topic: topic };

      this.subjects[topic] = this.subjects[topic] || [];
      this.subjects[topic].push(listener);

      this.debug('Adding "' + topic + '" topic listener for "' + clientId + '" client');

      return this;
    }
  }, {
    key: 'off',
    value: function off(clientId, topic, callback) {
      var fn = this.offClient;

      if (callback) {
        fn = this.offClientTopicCallback;
      } else if (topic) {
        fn = this.offClientTopics;
      }

      this.debug('Removing "' + topic + '" topic listener for "' + clientId + '" client');

      fn.call(this, clientId, topic, callback);

      return this;
    }

    /**
     * @private
     */

  }, {
    key: 'setClients',
    value: function setClients() {
      var _this = this;

      for (var _len = arguments.length, frames = Array(_len), _key = 0; _key < _len; _key++) {
        frames[_key] = arguments[_key];
      }

      Array.from(frames).map(function (frame) {
        return _this.setClient(frame);
      });
    }

    /**
     * @private
     */

  }, {
    key: 'createClient',
    value: function createClient(frame) {
      if (!utils.isElAnIframe(frame)) {
        throw new TypeError('Given frame is not an instance of the Iframe interface', frame);
      }

      var src = frame.src,
          clientId = frame.id;

      var targetOrigin = utils.getOriginFromUri(src);
      var sourceOrigin = utils.getOrigin();

      return {
        clientId: clientId,
        sourceOrigin: sourceOrigin,
        targetOrigin: targetOrigin,
        frame: frame,
        connected: false
      };
    }

    /**
     * @private
     */

  }, {
    key: 'setClient',
    value: function setClient(frame) {
      var client = this.createClient(frame);

      if (this.clients[client.clientId]) {
        /* eslint-disable no-console */
        console.warn('Client with given id ' + client.clientId + ' is already registered');
        /* eslint-enable no-console */
      }

      this.clients[client.clientId] = client;

      this.connectToClient(client.clientId);
    }

    /**
     * @private
     */

  }, {
    key: 'addEventHandlers',
    value: function addEventHandlers() {
      window.addEventListener(CONSTANTS.MESSAGE_EVENT_NAME, this.handleIncomingMessage);
    }

    /**
     * @private
     */

  }, {
    key: 'handleIncomingMessage',
    value: function handleIncomingMessage(event) {
      if (!utils.isEventMessageSupported(event)) {
        return;
      }

      var _utils$retrieveMessag = utils.retrieveMessageFromEvent(event),
          topic = _utils$retrieveMessag.topic,
          data = _utils$retrieveMessag.data,
          source = _utils$retrieveMessag.source,
          sourceOrigin = _utils$retrieveMessag.sourceOrigin;

      var listeners = this.subjects[topic];


      if (!Array.isArray(listeners)) {
        this.debug('Received message with "' + topic + '" topic but there are no listeners than can handle it');

        return;
      }

      this.debug('Received message with "' + topic + '" topic');

      listeners.forEach(function (listener) {
        var targetOrigin = listener.targetOrigin,
            callback = listener.callback;


        if (!utils.isMatchingOrigin(sourceOrigin, targetOrigin)) {
          return;
        }

        var message = { topic: topic, source: source, sourceOrigin: sourceOrigin, data: data };

        callback(message);
      });
    }

    /**
     * @private
     */

  }, {
    key: 'postMessageToClient',
    value: function postMessageToClient(clientId, topic, data) {
      var _getClient = this.getClient(clientId),
          frame = _getClient.frame,
          targetOrigin = _getClient.targetOrigin;

      var message = utils.buildMessage(topic, data);

      this.debug('Sending message with "' + topic + '" topic to "' + clientId + '" client');

      frame.contentWindow.postMessage(message, targetOrigin);
    }

    /**
     * @private
     */

  }, {
    key: 'connectToClient',
    value: function connectToClient(clientId) {
      var reconnect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.debug((reconnect ? 'Restarting' : 'Starting') + ' handshake polling for "' + clientId + '" client...');

      this.startHandshakePolling(clientId);

      this.on(clientId, CONSTANTS.BACK_HANDSHAKE_TOPIC, this.setClientAsConnected.bind(this, clientId));

      if (!reconnect) {
        this.on(clientId, CONSTANTS.CLIENT_DISCONNECTED_TOPIC, this.setClientAsDisconnected.bind(this, clientId));
      }
    }

    /**
     * @private
     */

  }, {
    key: 'startHandshakePolling',
    value: function startHandshakePolling(clientId) {
      this.intervals[clientId] = setInterval(this.sendHandshake.bind(this, clientId), this.config.handshakeInterval);
    }

    /**
     * @private
     */

  }, {
    key: 'sendHandshake',
    value: function sendHandshake(clientId) {
      this.postMessageToClient(clientId, CONSTANTS.HANDSHAKE_TOPIC);
    }

    /**
     * @private
     */

  }, {
    key: 'setClientAsConnected',
    value: function setClientAsConnected(clientId) {
      this.debug('Client "' + clientId + '" was connected');

      this.stopHandshakePooling(clientId);
      this.off(clientId, CONSTANTS.BACK_HANDSHAKE_TOPIC);

      var client = this.getClient(clientId);
      client.connected = true;

      this.deliverQueuedMessages(clientId);
    }

    /**
     * @private
     */

  }, {
    key: 'setClientAsDisconnected',
    value: function setClientAsDisconnected(clientId) {
      var client = this.getClient(clientId);
      client.connected = false;

      this.debug('Client ' + clientId + ' was disconnected');

      this.connectToClient(clientId, true);
    }

    /**
     * @private
     */

  }, {
    key: 'addMessageToQueue',
    value: function addMessageToQueue(message) {
      var clientId = message.clientId;

      this.debug('Adding message with "' + message.topic + '" topic to queue for "' + clientId + '" client');

      this.queue[clientId] = this.queue[clientId] || [];

      var queue = this.queue[clientId];

      queue.push(message);
    }

    /**
     * @private
     */

  }, {
    key: 'deliverQueuedMessages',
    value: function deliverQueuedMessages(clientId) {
      var _this2 = this;

      var messages = this.queue[clientId];

      if (!Array.isArray(messages) || messages.length < 1) {
        return;
      }

      this.debug('Delivering queued messages to "' + clientId + '" client');

      messages.forEach(function (message) {
        _this2.postMessage(message);
      });

      messages.length = 0;
    }

    /**
     * @private
     */

  }, {
    key: 'getClient',
    value: function getClient(clientId) {
      if (!this.clients.hasOwnProperty(clientId)) {
        /* eslint-disable no-console */
        console.warn('Given "' + clientId + '" client is not registered');
        /* eslint-enable no-console */
      }

      return this.clients[clientId];
    }

    /**
     * @private
     */

  }, {
    key: 'postMessage',
    value: function postMessage(message) {
      var clientId = message.clientId,
          topic = message.topic,
          data = message.data;

      var client = this.getClient(clientId);

      if (!utils.isClientConnected(client)) {
        this.addMessageToQueue(message);

        return;
      }

      this.postMessageToClient(clientId, topic, data);
    }

    /**
     * @private
     */

  }, {
    key: 'offClient',
    value: function offClient(clientId) {
      var _this3 = this;

      Object.entries(this.subjects).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            topic = _ref2[0],
            listeners = _ref2[1];

        return [topic, listeners.filter(function (listener) {
          return listener.clientId !== clientId;
        })];
      }).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            topic = _ref4[0],
            listeners = _ref4[1];

        _this3.subjects[topic] = listeners;
      });
    }

    /**
     * @private
     */

  }, {
    key: 'offClientTopics',
    value: function offClientTopics(clientId, topic) {
      var listeners = this.subjects[topic];


      if (!Array.isArray(listeners) || listeners.length < 1) {
        return;
      }

      listeners = listeners.filter(function (listener) {
        return listener.clientId !== clientId;
      });

      this.subjects[topic] = listeners;
    }

    /**
     * @private
     */

  }, {
    key: 'offClientTopicCallback',
    value: function offClientTopicCallback(clientId, topic, callback) {
      var listeners = this.subjects[topic];


      if (!Array.isArray(listeners) || listeners.length < 1) {
        return;
      }

      listeners = listeners.filter(function (listener) {
        return listener.clientId !== clientId && listener.callback !== callback;
      });

      this.subjects[topic] = listeners;
    }

    /**
     * @private
     */

  }, {
    key: 'stopHandshakePooling',
    value: function stopHandshakePooling(clientId) {
      var interval = this.intervals[clientId];

      if (!clientId) {
        return;
      }

      this.debug('Handshake polling for "' + clientId + '" client was stopped');

      clearTimeout(interval);
      delete this.intervals[clientId];
    }

    /**
     * @private
     */

  }, {
    key: 'debug',
    value: function debug(message) {
      var debugCallback = this.config.debugCallback;

      if (!this.config.debug || typeof debugCallback !== 'function') {
        return;
      }

      debugCallback('Trainman: ' + message);
    }
  }]);

  return Trainman;
}();

exports.default = Trainman;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trainman = exports.Passenger = undefined;

var _trainman = __webpack_require__(3);

var _trainman2 = _interopRequireDefault(_trainman);

var _passenger = __webpack_require__(2);

var _passenger2 = _interopRequireDefault(_passenger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Passenger = _passenger2.default;
exports.Trainman = _trainman2.default;
exports.default = _trainman2.default;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// trainmanjs.js